import { isNil } from 'lodash';

import { parsePhoneNumber } from 'awesome-phonenumber';

const isCorrectPhoneNumber = ({ phoneNumber, required = false }) => {
  if (phoneNumber === '' && !required) return true;

  if (!isNil(phoneNumber) && phoneNumber !== '') {
    return parsePhoneNumber(phoneNumber)?.valid;
  }
  return false;
};

export default isCorrectPhoneNumber;
